function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sprouts",
  transform: "translate(-30.969 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_134",
  "data-name": "Path 134",
  d: "M104.881,95.732A10.742,10.742,0,1,1,119.4,79.9c21.831,20,38.619,39.235,51.131,58.73,12-85.4-41.842-132.494-127.467-138.539A10.748,10.748,0,0,0,31.174,12.815C41.982,67.771,53.506,100.4,68.54,118.608c23.292,28.219,50.157,19.288,83.34,30.654-10.808-16.559-25.877-34.171-47-53.531Z",
  transform: "translate(0 0)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_135",
  "data-name": "Path 135",
  d: "M261.625,193.552a186.883,186.883,0,0,0-21.594,45.838,186.873,186.873,0,0,0-21.594-45.838c-1.332,9.719-5.372,15.191-18.65,10.636,20.935,32.073,25.892,60.22,27.9,89.521a74.361,74.361,0,0,1,24.681,0c2.013-29.3,6.969-57.448,27.9-89.521-8.2,2.815-16.624,4.2-18.651-10.636Z",
  transform: "translate(-47.906 -54.925)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_136",
  "data-name": "Path 136",
  d: "M412.93.087c-15.635,1.1-29.222,3.087-44.521,7.656-60.843,18.156-92.472,63.15-82.946,130.883,12.512-19.5,29.3-38.726,51.131-58.73a10.742,10.742,0,1,1,14.518,15.836c-21.121,19.36-36.191,36.972-47,53.531,33.176-11.359,60.048-2.435,83.34-30.654,15.034-18.206,26.558-50.838,37.365-105.794A10.748,10.748,0,0,0,412.93.087Z",
  transform: "translate(-71.745 0)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_137",
  "data-name": "Path 137",
  d: "M300.177,405.324a42.73,42.73,0,0,0-47.272-20.66,53.5,53.5,0,0,0-87.5,0,42.731,42.731,0,0,0-47.272,20.66,32.232,32.232,0,0,0,5.077,64.061H295.1a32.232,32.232,0,0,0,5.077-64.061Z",
  transform: "translate(-17.029 -102.713)",
  fill: "#65ccb8"
}));

function SvgSprouts1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 322.312,
    height: 366.672,
    viewBox: "0 0 322.312 366.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprouts1);
export default __webpack_public_path__ + "static/media/sprouts-1.20d779df.svg";
export { ForwardRef as ReactComponent };